import { ReportFieldType } from '..';

export class ReportUtility {

    /**
     * Is Entity type or not
     * @param fieldType 
     * @returns 
     */
    static isNotPrimitiveType(fieldType: ReportFieldType): boolean {

        const isNotNumeric = !this.isNumericType(fieldType);
        const isNotOtherPrimitive = [
            ReportFieldType.Date,
            ReportFieldType.String,
            ReportFieldType.Link,
            ReportFieldType.RichText,
            ReportFieldType.Boolean,
        ].indexOf(fieldType) === -1;

        return isNotNumeric && isNotOtherPrimitive;
    }

    static isNumericType(fieldType: ReportFieldType): boolean {
        return [
            ReportFieldType.Number,
            ReportFieldType.Decimal,
            ReportFieldType.Currency,
        ].indexOf(fieldType) > -1
    }


    /**
     * Use only for Special cases check in report.logic query builder
     * Eg: job status define type as 'status' type but return 'string' type
     * @param fieldType 
     * @returns 
     */
    static isEntityType(fieldType: ReportFieldType): boolean {
        if (
            (this.isNotPrimitiveType(fieldType) && fieldType !== ReportFieldType.Status)
            || fieldType === ReportFieldType.EntityStatus
        ) {
            return true
        }

        return false
    }
}